import { useEffect, useLayoutEffect, useRef, useState } from "react";



export function useScrollPosition() {
    const divRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0, isEndX: false, isEndY: false, hasScrollX: false, hasScrollY: false, width: 0, height: 0 });
    
    const calcProps = (target) => {
        const isEndY = target.scrollHeight - target.scrollTop === target.clientHeight;
        const isEndX = target.scrollWidth - target.scrollLeft === target.clientWidth; 
        const hasScrollX = target.scrollWidth > target.clientWidth;
        const hasScrollY = target.scrollHeight > target.clientHeight;
        const x = target.scrollLeft;
        const y = target.scrollTop;
        const width = target.clientWidth;
        const height = target.clientHeight;
        return { x, y, isEndX, isEndY, hasScrollX, hasScrollY, width, height };
    }
    useEffect(() => {
        const onScroll = (e) => {
            var props = calcProps(e.target);
            console.log(props);
            setScrollPosition(props);
        }
        if(divRef.current) {
            divRef.current.addEventListener("scroll", onScroll, { passive: true });
        }

        
        return () => {
            
            divRef.current?.removeEventListener("scroll", onScroll);
            
        }
    },[divRef.current]);

    useLayoutEffect(() => {
        if(divRef.current) {
            const sizeChanged = scrollPosition.width !== divRef.current.clientWidth || scrollPosition.height !== divRef.current.clientHeight;
            if(sizeChanged) {
                var props = calcProps(divRef.current);
                setScrollPosition(props);
            }
        }
    });

    return {
       scrollPosition,
       divRef
    };
}



export function useResizeObserver() {
    const elRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    useEffect(() => {
        if (elRef.current) {
            const observer = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    setDimensions({
                        width: entry.contentRect.width,
                        height: entry.contentRect.height,
                    });
                }
            });

            observer.observe(elRef.current);

            // Cleanup function
            return () => {
                observer.disconnect();
            };
        }
    }, []);  

    // update dimensions also on first render
    useLayoutEffect(() => {
        if (elRef.current) {
            setDimensions({
                width: elRef.current.offsetWidth,
                height: elRef.current.offsetHeight,
            });
        }
    }, [elRef.current]);
    
    return {
        dimensions,
        elRef
    };
}